import React from 'react';
import {useParams} from "react-router-dom";
import CommonProduct from "../Component/CommonProduct";


type Params = {
    id?: string;
}

const ProductUpdate = () => {
    let params = useParams<Params>();

    return (
        <div>
            <CommonProduct id={Number(params.id)}/>
        </div>
    );
};

export default ProductUpdate;